




































import { Component, Prop, Vue } from "vue-property-decorator";
import * as def from "@/definitions";

import { UserAgentHelper } from "@/helper/userAgentHelper"
import { DebugHelper } from "@/helper/debugHelper";
import { ResourceHelper } from "@/helper/resourceHelper";
import { CookieHelper } from "@/helper/cookieHelper";

import CheckOn from "./resources/checkOn.vue";

@Component({
  components: {
      CheckOn
  }
})
export default class PrintConfirmation extends Vue 
{
    isVisible = false;
    ischeck = false;
    onOkCallback : (() => void) | null = null;

    get message(){
        var msg = "";
        if (UserAgentHelper.isElectron()) {
            msg = "プリンターのプロパティからパッケージに記載されている印刷設定を行なってください。";
        }
        else if(UserAgentHelper.getBrowser() === "chrome"){
            msg = "詳細設定にある倍率は[100％]、余白は[既定]で印刷してください。<br>"
                + "また、エプソン社インクジェットプリンターでＡ４サイズ以外の用紙をご利用の場合は、<br>"
                + "事前にＰＣの設定からプリンタードライバーを開き用紙サイズの変更を行ってください。<br>"
                + "詳しくはこちらをご確認ください。<br>"
                + "<a href='https://www.a-one.co.jp/product/support/detail.php?id=1329' target='_blank'>https://www.a-one.co.jp/product/support/detail.php?id=1329</a>";
        }
        else if(UserAgentHelper.getBrowser() === "edge"){
            msg = "PDFファイルがダウンロードされます。<br>"
                + "Adobe Acrobat Reader等のPDFビューアーでファイルを開いて印刷してください。<br>"
                + "ページサイズに[合わせる]は選択せずに、[実際のサイズ]または[100％]で印刷してください。<br>"
                + "Microsoft Edgeは自動的にページサイズに合わせてしまうため、他のPDFビューアーをご利用ください。";
        }
        else if(UserAgentHelper.getBrowser() === "safari" || UserAgentHelper.getBrowser() === "ie")
        {
            msg = "PDFファイルがダウンロードされます。<br>"
                + "Adobe Acrobat Reader等のPDFビューアーでファイルを開いて印刷してください。<br>"
                + "ページサイズに[合わせる]は選択せずに、[実際のサイズ]または[100％]で印刷してください。";
        }
        else if(UserAgentHelper.getBrowser() === "firefox"){
            let cmd = UserAgentHelper.getOS() == "MacOS" ? "プリントします" : "印刷します";
            msg = "印刷プレビュー右上の[" + cmd + "]から印刷してください。プリンタードライバーで[用紙サイズ]を選択し、拡大・縮小はせずに[等倍]に設定してください。";
        }
        return msg;
    }

    getResource(file : string){
        return ResourceHelper.getResource(file);
    }

    get marginStyle(){
        var style = {};
        if (UserAgentHelper.isElectron()) {
            style = {
                "margin-top": "45px"
            };
        }
        else {
            style = {
                "margin-top" : "15px"
            };
        }
        return style;
    }

    get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }

    private get buttonColorStyle(){
        return {
            "background-color" : this.userConfigColor
        }
    }

    public open(onOk : () => void)
    {
        // Cookieで「表示しない」の場合は、okコマンドをそのまま実行する
        if(CookieHelper.hasItem("printConfirmationForChromeOrEdgeVisible"))
        {
            onOk();
            return;
        }

        if(UserAgentHelper.isElectron() ||
            UserAgentHelper.getBrowser() === "chrome" || 
            UserAgentHelper.getBrowser() === "edge" ||
            UserAgentHelper.getBrowser() === "safari" || 
            UserAgentHelper.getBrowser() === "firefox" ||
            UserAgentHelper.getBrowser() === "ie")
        {
            // ダイアログを表示する
            this.onOkCallback = onOk;
            this.isVisible = true;
        }
        else
        {
            // その他の環境の場合はokコマンドをそのまま実行する
            onOk();
        }
    }

    onOk()
    {
        if(this.ischeck){
            CookieHelper.setItem("printConfirmationForChromeOrEdgeVisible", true);
        }
        // okコマンド実行
        if(this.onOkCallback != null) this.onOkCallback();
        // 閉じる
        this.isVisible = false;
    }

}
